import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import ImageTextSection from "../../components/ImageTextSection";
import NumbersFlow from "../../components/NumbersFlow";
import Seo from "../../components/Seo";
import {
  benefitsData,
  collectionStepsData,
  featuresCardData,
} from "../../data/medicalBilling";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";
import section1Image from "./medicalbilling_section1.webp";
import section2Image from "./medicalbilling_section2.webp";
import section3Image from "./medicalbilling_section3.webp";
import section4Image from "./medicalbilling_section4.webp";

const seo = {
  title: "Explore Our Billing Service | MIT4Doctors",
  description:
    "Medical Imaging Technology Services offers more than basic billing solutions. We provide full Revenue Cycle Management (RCM) services.",
  schema: [
    createWebPageSchema({
      path: "/services/medical-billing-services",
      title: "Explore Our Billing Service",
      description:
        "Medical Imaging Technology Services offers more than basic billing solutions. We provide full Revenue Cycle Management (RCM) services.",
    }),
    createBreadcrumbSchema(
      "/services/medical-billing-services",
      "Explore Our Billing Service",
    ),
  ],
};

export default function MedicalBilling() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/medical-billing-services"
        schema={seo.schema}
      />
      <BannerComp
        heading="Explore Our Billing Service"
        paragraph="Medical Imaging Technology Services offers more than basic billing solutions. We provide full Revenue Cycle Management (RCM) services."
        centered
        BannerBgImg="/img/banners/medicalBilling_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Billing Made Secure & Simple Solutions"
        imagePosition="left"
        title="Billing Made Secure & Simple Solutions"
        description="We provide full Revenue Cycle Management (RCM) services to speed up your financial processes. This includes everything from billing and coding to collections, and it is crucial.
      Our advanced, HIPAA-compliant solutions make things more efficient and effective. We collect more than 97% of claims on the first try and bring in 10% to 15% more in collections than most in the industry. And we do all this for a competitive rate of 5%."
        highlightWords="Simple Solutions"
      />

      <IconBenefitGrid
        title="Our Expertise in Revenue Cycle"
        description="Here's how we make your earnings process smoother and faster. We accurately register each patient and actively manage denials. This means you always get paid on time. Your money stream stays regular, which keeps your practice stable."
        highlightWords="Revenue Cycle"
        items={benefitsData}
      />

      <FeatureImageContent
        heading="Secure, Compliant Billing Work"
        description="Focus on patients while we handle your billing. MITSI swift, accurate solutions cover coding to collections, ensuring compliance and precision. Partner with us for smooth medical administration."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Secure, Compliant Billing Work"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Credentialing Services for Your Practice"
        imagePosition="right"
        title="Credentialing Services for Your Practice"
        description="Establishing your practice and securing revenue starts with efficient credentialing. At Medical Imaging Technology Services (MIT), our credentialing team speeds up insurance authorizations. We manage the application process and update your info to meet regulations. We also maintain your CAQH profile."
        highlightWords="Your Practice"
      />

      <FeatureCard
        sectionTitle="Spot-on Medical Coding"
        sectionDescription="Our expert coders ensure precise, compliant coding. This leads to faster reimbursements and reduced claim rejections."
        highlightText="Medical Coding"
        features={featuresCardData}
      />

      <NumbersFlow
        eyebrow="Our Collection Process"
        heading="Successful Collection"
        highlights={["Collection"]}
        intro="We streamline medical billing, improve payment collection, and strengthen cash flow with efficient revenue cycle strategies."
        steps={collectionStepsData}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Why Is Our Medical Billing Service Ideal?"
        imagePosition="right"
        title="Why Is Our Medical Billing Service Ideal?"
        description="Partner with experts to streamline your billing and maximize revenue. We process claims accurately and quickly. We ensure compliance and provide clear reports."
        highlightWords="Service Ideal?"
        subSections={[
          {
            listItems: [
              "Skilled Professionals: Expert billing that increases your earning potential.",
              "Devotion to Compliance: We ensure accurate coding and meet all industry standards.",
              "Adapted Support for Growth: Flexible billing solutions that grow with your practice.",
              "Quick Revenue Cycle Management: High first-pass claim acceptance for quicker reimbursements.",
              "Clear Reporting: Transparent, easy-to-understand reports for better decision-making.",
            ],
            listItemBoldText: [
              "Skilled Professionals",
              "Devotion to Compliance",
              "Adapted Support for Growth",
              "Quick Revenue Cycle Management",
              "Clear Reporting",
            ],
          },
        ]}
      />

      <ImageTextSection
        image={section4Image}
        imageAlt="Fast Track Certification & Enrollment"
        imagePosition="left"
        title="Fast Track Certification & Enrollment"
        description="MITSI provider enrollment and credentialing services ensure compliance with state and federal regulations. This allows you to deliver healthcare services with full authorization. We monitor each application to ensure a smooth, complete enrollment. Our team regularly follows up to do this."
        highlightWords="Enrollment"
      />
    </>
  );
}
